<template>
	<div>
		<div :id="'echartContainer'+idname" class=""
			style="width: 168px;height: 154px;position: relative;top: -60px;left: -16px;"></div>
	</div>
</template>

<script>
	const echarts = require('echarts');
	export default {
		name: 'line-chart',
		props: ['idname','item','color'],
		// props: {
		// 	idname: {
		// 	  type: String,
		// 	  required: true,
		// 	},
		// 	item: {
		// 	  type: Array,
		// 	  required: true,
		// 	},
		// },

		data() {
			return {
				arr: [],
				tiem: null,
			}
		},
		mounted() {
			let _this = this;
			if(this.item != undefined){
				if(this.item.length >= 1){
					this.item.forEach((item,index)=>{
						_this.arr.push(Number(item.close))
					})
				}
			}
			this.tiem = setInterval(()=>{
				if(_this.arr.length > 0){
					_this.kline();
					clearInterval(_this.tiem)
				}
			},1000)
		},
		methods: {
			kline() {
				let _this = this;
				console.log(_this.arr)
				var chartDom = document.getElementById('echartContainer' + this.idname);
				var myChart = echarts.init(chartDom);
				myChart.resize();
				var option;

				option = {
					xAxis: {
						type: 'category',
						boundaryGap: false,
						show: false,
						"axisLine": { //y轴
							"show": false
						},
						"axisTick": { //y轴刻度线
							"show": false
						},
						"splitLine": { //网格线
							"show": false
						},
						axisLabel: {
							rotate: 30, // 旋转角度
							interval: 0 //设置X轴数据间隔几个显示一个，为0表示都显示
						},
					},
					yAxis: {
						min:function(value){
							return value.min;
						},
						type: 'value',
						show: false,
						spliLine: {
							show: false
						}
					},
					series: [{
						data: _this.arr,
						symbol: "none",
						itemStyle: {
							normal: {
								borderColor: _this.color,
								lineStyle: {
									color: _this.color,
								}
							}
						},
						type: 'line',
						smooth: true,
						x: 1,
						y: 1,
						x2: 1,
						y2: 1,
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: _this.color // 100% 处的颜色
								}, {
									offset: 1,
									color: '#FFFFFF' //   0% 处的颜色
								}],
								global: false // 缺省为 false
							}
						},
					}],
					erid: {
						left: '1%',
						right: '1%',
						containLabel: true
					}
				};
				option && myChart.setOption(option);
				window.addEventListener("resize", function() {
					// oChart.resize();
				});
			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts.vue